export function policyChanges(current,draft) {
 const changes=[];
 if(current.execution_mode!==draft.execution_mode && draft.execution_mode==="host_firewall")changes.push("Use host firewall enforcement on the intended enforcement host.");
 if(current.execution_mode!==draft.execution_mode && draft.execution_mode==="agent_firewall")changes.push("Use the designated healthy site gateway for enforcement.");
 if(!current.auto_execute_enabled && draft.auto_execute_enabled)changes.push("Allow automatic execution without a per-action approval.");
 if(current.dry_run && !draft.dry_run && draft.execution_mode!=="propose_only")changes.push("Turn off Dry Run and permit real firewall changes.");
 if(current.emergency_stop && !draft.emergency_stop)changes.push("Turn off Emergency Stop.");
 if(current.require_approval && !draft.require_approval)changes.push("Turn off the normal approval requirement.");
 return changes;
}
export function autonomyChanges(current,draft) {
 const changes=[];
 const level=Number(draft.autonomy_level||0);
 if(Number(current.autonomy_level||0)<3 && level>=3)changes.push("Enable automated response at level "+level+".");
 if(current.simulation_mode && !draft.simulation_mode && level>=3)changes.push("Turn off Simulation Mode for qualifying automated decisions.");
 if(current.kill_switch && !draft.kill_switch)changes.push("Turn off the autonomy kill switch.");
 return changes;
}
